import React, { Component, PropTypes } from 'react'
import get from 'lodash/get'
import SelectField from 'material-ui/SelectField'
import MenuItem from 'material-ui/MenuItem'
import Toggle from 'material-ui/Toggle'

class InstitutionSchoolSelector extends Component<any, any> {
  handleSelectChange = (event, index, value) => {
    // school_or_college_not_listed lives on a different field.prop than this
    // component is bound to (school_or_college_id); the field system re-reads
    // resource[field.prop] fresh on every render, so mutating it directly
    // here and letting the sanctioned onChange below trigger the re-render
    // keeps both in sync without a second onChange wired up.
    this.props.resource.school_or_college_not_listed = false
    this.props.onChange(event, value)
  }

  handleNotListedToggle = (event, checked) => {
    this.props.resource.school_or_college_not_listed = checked
    this.props.onChange(event, checked ? null : this.props.value)
  }

  render () {
    const options = get(this.props.resource, 'institution_relation.school_or_college_options', [])

    if (!options || options.length === 0) {
      return <div />
    }

    const notListed = !!this.props.resource.school_or_college_not_listed

    return (
      <div>
        <SelectField
          floatingLabelText={this.props.label}
          value={this.props.value}
          onChange={this.handleSelectChange}
          errorText={this.props.errorText}
          disabled={notListed}
        >
          <MenuItem value={null} primaryText='' />
          {options.map(option => {
            return <MenuItem
              key={option.id}
              value={option.id}
              primaryText={option.name}
            />
          })}
        </SelectField>
        <Toggle
          label='Not Listed'
          labelPosition='right'
          toggled={notListed}
          onToggle={this.handleNotListedToggle}
          style={{ marginTop: '1em', maxWidth: '256px' }}
        />
      </div>
    )
  }
}

// @ts-ignore
InstitutionSchoolSelector.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  errorText: PropTypes.string,
  resource: PropTypes.object
}

// @ts-ignore
InstitutionSchoolSelector.defaultProps = {
  value: null,
  errorText: null
}

export default InstitutionSchoolSelector
